import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicJobs } from '../services/publicService';
import './CareersPage.css';

const hiringTitleWords = ['We', 'are', 'Hiring'];

const CareersPage = () => {

  const [jobs, setJobs] = useState([]); // always array
  const [loading, setLoading] = useState(true);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const [titleScrollOffset, setTitleScrollOffset] = useState(0);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await getPublicJobs();

        // SAFE DATA HANDLING
        if (res && Array.isArray(res.jobs)) {
          setJobs(res.jobs);
        } else {
          console.warn('Invalid jobs response:', res);
          setJobs([]);
        }

      } catch (error) {
        console.error('Error fetching jobs:', error);
        setJobs([]); // fallback to prevent crash
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    const revealTimer = window.setTimeout(() => {
      setIsTitleVisible(true);
    }, 80);

    const handleScroll = () => {
      const scrollY = window.scrollY;
      setTitleScrollOffset(Math.min(scrollY * 0.22, 140));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.clearTimeout(revealTimer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const titleStyle = {
    opacity: isTitleVisible ? 1 : 0,
    transform: isTitleVisible
      ? `translate3d(0, ${-titleScrollOffset * 0.3}px, 0)`
      : 'translate3d(0, 60px, 0)',
    transition:
      'opacity 900ms ease 120ms, transform 1100ms cubic-bezier(0.22, 1, 0.36, 1) 120ms'
  };

  return (
    <div className="footer-careers-wrapper">
      <div className="footer-careers-container">

        <div className="back-link">
          <Link to="/">← Back to Home</Link>
        </div>

        <div className="careers-hero">
          <h1 className="careers-title">
            <span
              className={`careers-title-text${isTitleVisible ? ' is-visible' : ''}`}
              style={titleStyle}
              aria-label="We are Hiring"
            >
              <span className="careers-title-line">
                {hiringTitleWords.map((word, wordIndex) => {
                  const letterOffset =
                    hiringTitleWords
                      .slice(0, wordIndex)
                      .reduce((count, currentWord) => count + currentWord.length, 0) + wordIndex;

                  return (
                    <span key={word} className="careers-title-word">
                      {word.split('').map((letter, letterIndex) => (
                        <span
                          key={`${word}-${letterIndex}`}
                          className="careers-title-letter"
                          style={{ '--reveal-order': letterOffset + letterIndex + 1 }}
                        >
                          {letter}
                        </span>
                      ))}
                    </span>
                  );
                })}
              </span>
            </span>
          </h1>

          <p>
            Join our AI-driven teams and help build intelligent solutions for the future.
          </p>
        </div>

        <section className="careers-section">
          <h2>Open Positions</h2>

          {/*  Loading State */}
          {loading && <p>Loading jobs...</p>}

          {/*  Empty State Safe */}
          {!loading && (!jobs || jobs.length === 0) && (
            <p>No jobs available</p>
          )}

          {/*  Safe Mapping */}
          <div className="jobs-grid">
            {Array.isArray(jobs) && jobs.map(job => (
              <Link
                to={`/careers/${job.id}`}
                className="job-card"
                key={job.id}
              >
                <div className="job-card-top">
                  <span className="job-id">{job.job_code}</span>
                </div>

                <h3>{job.title}</h3>

                <div className="job-card-footer">
                  <span className="view-text">View →</span>
                </div>
              </Link>
            ))}
          </div>

        </section>

      </div>
    </div>
  );
};

export default CareersPage;
